import { Link } from "react-router-dom";
import { ArrowLeft, ShoppingCart, BookOpen } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Disclosure() {
  const { user } = useAuth();
  const back = user ? "/home" : "/";
  return (
    <div data-testid="disclosure-container" className="min-h-screen bg-[#FDFBF7]">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-14">
        <Link to={back} className="inline-flex items-center gap-1.5 text-sm text-[#2C2520]/70 hover:text-[#2C2520]">
          <ArrowLeft className="w-4 h-4" strokeWidth={1.5} /> Back
        </Link>
        <div className="label-caps mt-8 mb-4">Affiliate disclosure</div>
        <h1 className="font-serif-display text-4xl sm:text-5xl text-[#2C2520] tracking-tight">
          How we quietly keep the lights on.
        </h1>

        <div className="mt-10 space-y-8 text-[#2C2520]/85 leading-relaxed">
          <p className="font-serif-display italic text-lg text-[#2C2520] border-l-2 border-[#4A5D4E] pl-4">
            Bibliotherapy Companion is free, and we intend to keep it that way. When you buy a book through one of
            our access links, we may earn a small commission at no extra cost to you. That is the only way we
            currently earn from the app.
          </p>

          <section className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-[10px] bg-[#F5F2EA] border border-[#E8E3D5] flex items-center justify-center flex-shrink-0">
              <ShoppingCart className="w-5 h-5 text-[#4A5D4E]" strokeWidth={1.5} />
            </div>
            <div>
              <h2 className="font-serif-display text-xl text-[#2C2520]">Amazon Associates</h2>
              <p className="mt-2 text-[#2C2520]/80">
                As an Amazon Associate, we earn from qualifying purchases. When you tap "Buy on Amazon" or
                "Audiobook on Audible," you'll be sent to Amazon's site with our affiliate tag attached. If you
                buy anything on Amazon within a short window afterward, we earn a small percentage of that sale.
              </p>
            </div>
          </section>

          <section className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-[10px] bg-[#F5F2EA] border border-[#E8E3D5] flex items-center justify-center flex-shrink-0">
              <BookOpen className="w-5 h-5 text-[#4A5D4E]" strokeWidth={1.5} />
            </div>
            <div>
              <h2 className="font-serif-display text-xl text-[#2C2520]">Bookshop.org</h2>
              <p className="mt-2 text-[#2C2520]/80">
                Bookshop.org supports independent bookstores. When you tap "Buy indie (Bookshop)," a portion of your
                purchase supports local bookshops, and Bibliotherapy Companion may receive a small referral
                commission as well.
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-serif-display text-xl text-[#2C2520] mb-3">Our promise</h2>
            <ul className="list-disc pl-5 space-y-1.5 text-[#2C2520]/85">
              <li>Recommendations are chosen based on how you feel, not what earns the most commission.</li>
              <li>Book picks come from an AI trained on literary sensibility, not sponsored placements.</li>
              <li>We never adjust which books we suggest to favor affiliate payouts.</li>
              <li>You always have alternatives, including free options like Open Library and your local library.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif-display text-xl text-[#2C2520] mb-3">In line with the FTC</h2>
            <p className="text-[#2C2520]/80">
              This disclosure exists to comply with the U.S. Federal Trade Commission's guidelines on endorsements
              and testimonials, as well as similar transparency requirements in other regions. Thank you for
              reading it, and thank you for supporting the app when you buy through our links.
            </p>
          </section>

          <p className="text-sm text-[#2C2520]/55">
            See also our <Link to="/privacy" className="text-[#4A5D4E] underline underline-offset-4">Privacy Policy</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}
